// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rodape_rodape__-vxHp {
  padding: 2rem 1.5rem;
  text-align: center;
  border-top: 1px solid hsl(222, 30%, 14%);
}

.Rodape_texto__qenh3 {
  font-size: 0.8rem;
  color: hsl(215, 20%, 40%);
}

.Rodape_destaque__0mtiN {
  color: hsl(217, 91%, 60%);
}
`, "",{"version":3,"sources":["webpack://./src/components/Rodape/Rodape.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".rodape {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  border-top: 1px solid hsl(222, 30%, 14%);\n}\n\n.texto {\n  font-size: 0.8rem;\n  color: hsl(215, 20%, 40%);\n}\n\n.destaque {\n  color: hsl(217, 91%, 60%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rodape": `Rodape_rodape__-vxHp`,
	"texto": `Rodape_texto__qenh3`,
	"destaque": `Rodape_destaque__0mtiN`
};
export default ___CSS_LOADER_EXPORT___;
